export default __webpack_public_path__ + "static/media/ok-icon.9d38db5e.svg";